import { render, staticRenderFns } from "./LeaveDashboard.vue?vue&type=template&id=2b19b154&scoped=true&"
import script from "./LeaveDashboard.vue?vue&type=script&lang=js&"
export * from "./LeaveDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LeaveDashboard.vue?vue&type=style&index=0&id=2b19b154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19b154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VAutocomplete,VCard,VCol,VContainer,VRow,VSnackbar})
